import { Empresa } from '../../Cadastros/Empresas/types';
import { dataHoraPtBr, diasEntre, hojeLocal } from '../../../utils/data';

export { dataHoraPtBr, hojeLocal };

/**
 * Regra de saude da integracao ERP -> Entregas.
 *
 * Fica fora da tela de proposito: e ela que decide se um cliente esta
 * integrado, e precisa ser conferivel sem render, sem API e sem relogio -- por
 * isso `hoje` entra por parametro em vez de sair de `new Date()` aqui dentro.
 */

export type EstadoSaude =
  | 'ok'
  | 'atrasada'
  | 'nunca'
  | 'incompleta'
  | 'inativa';

export interface Saude {
  estado: EstadoSaude;
  rotulo: string;
  detalhe: string;
}

const vazio = (valor: string | null | undefined) => !valor || !valor.trim();

export const avaliaSaude = (empresa: Empresa, hoje: string): Saude => {
  // inativa ganha de tudo: nao faz sentido cobrar configuracao de quem nao
  // usa o sistema, e a linha viraria ruido permanente no relatorio
  if (!empresa.ativo) {
    return {
      estado: 'inativa',
      rotulo: 'Inativa',
      detalhe: 'Empresa inativa; a integração não é cobrada.',
    };
  }

  const semUrl = vazio(empresa.url_erp);
  const semToken = empresa.token_origem === '';

  // configuracao incompleta ganha de "nunca sincronizou": as duas sao verdade
  // ao mesmo tempo, e a acionavel e a configuracao
  if (semUrl || semToken) {
    const falta =
      semUrl && semToken
        ? 'Faltam a URL e o token do ERP.'
        : semUrl
        ? 'Falta a URL do ERP.'
        : 'Falta o token do ERP.';

    return { estado: 'incompleta', rotulo: 'Configuração incompleta', detalhe: falta };
  }

  if (!empresa.ultima_sincronizacao) {
    return {
      estado: 'nunca',
      rotulo: 'Nunca sincronizou',
      detalhe: 'Configurada, mas nenhum motorista sincronizou ainda.',
    };
  }

  const dias = diasEntre(hoje, empresa.ultima_sincronizacao);

  // comparacao por DATA, e nao por diferenca de horas: sincronismo de
  // madrugada continua sendo "hoje"
  if (dias <= 0) {
    return {
      estado: 'ok',
      rotulo: 'Integrada',
      detalhe: `Sincronizada hoje às ${dataHoraPtBr(
        empresa.ultima_sincronizacao
      ).slice(-5)}.`,
    };
  }

  return {
    estado: 'atrasada',
    rotulo: 'Atrasada',
    detalhe: `Sem sincronizar há ${dias} ${dias === 1 ? 'dia' : 'dias'}.`,
  };
};

export interface ResumoSaude {
  total: number;
  integradas: number;
  atrasadas: number;
  /** Precisam de acao: configuracao incompleta ou nunca sincronizaram. */
  pendentes: number;
}

export const resumo = (empresas: Empresa[], hoje: string): ResumoSaude => {
  const estados = empresas.map((e) => avaliaSaude(e, hoje).estado);
  const conta = (estado: EstadoSaude) =>
    estados.filter((e) => e === estado).length;

  return {
    total: empresas.length,
    integradas: conta('ok'),
    atrasadas: conta('atrasada'),
    pendentes: conta('incompleta') + conta('nunca'),
  };
};
